import { useState } from 'react'

import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  requestTo
} from "../../components/action-buttons/ActionButtonGenerator";
import { Field } from "formik";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import CheckboxComponent from "../../components/form-fields/CheckboxComponent";
import Checkbox from "../../components/form-fields/Checkbox";
import FileUpload from "../../components/fields/FileUpload";
import Main from "../../components/main/Main";

import { Nav, Tab } from "react-bootstrap";

import { formatDate } from "../../utils";
import { useTranslation } from "react-i18next";

import UserRole from "./User-Role";
import UserDepartment from "./User-Department";
import request from "../../services/request";

const UserModal = ({ showModal, setShowModal, isUpdating, selectedRow, refreshList, setRefreshList, StatusCheckBoxValue, initialValuesArchive, setInitialValuesArchive }) => {

    const [initialValues, setInitialValues] = useState({});
    const [initialValuesFile, setInitialValuesFile] = useState({ id: null });

    const [refreshFileList, setRefreshFileList] = useState(false);

    const validationSchema = yup.object({});

    const validationSchema_file = yup.object({
        fileId: yup.array().required("Dosya gerekli"), // does not work burakcım! 
        descr: yup.string().required("Açıklama gerekli"),
    });
    
    const arrangeBeforePersist = (values) => {

        let payload = {
          id: values.id,
          fullName: values.fullName,
          email: values.email,
          username: values.username,
          avukatKod: values.avukatKod,
          masrafCheck: values.masrafCheckUpdate,
          stId: values.stId || 90,
        };
        return payload;
    };

    const adaptDataForUpdate = (data) => {
        let adaptedData = {
          id: data.id,
          stId: data.stId,
          fullName: data.fullName,
          email: data.email,
          username: data.username,
          avukatKod: data.avukatKod,
          mobilePhone: data.mobilePhone,
          masrafCheck: data.masrafCheck
        };
        setInitialValues(adaptedData);
        // setMasrafCheckBoxVal(data.masrafCheck);
    };

    const arrangeBeforePersistArchive = (values) => {
        let payload = {
          id: values.id,
          arsivYonetimIds: values.arsivYonetimIds,
        };
        return payload;
    };
    
    const adaptDataForUpdateArchive = (data) => {
        let adaptedData = {
          id: data.id,
          arsivYonetimIds: data.arsivYonetimIds,
        };
        setInitialValuesArchive(adaptedData);
    };

    const arrangeBeforePersistFile = (values) => {
        let payload = {
          userId: selectedRow.id,
          descr: values.descr,
          fileId: values.fileId[0].id,
          path: values.fileId[0].path,
        };
        return payload;
    };
      
    const adaptDataForUpdateFile = (data) => {
        setInitialValuesFile(
          data.tableData.map((tc) => {
            return {
              id: tc.id,
              fileId: tc.fileId,
              descr: tc.descr,
              filename: tc.filename,
            };
          })
        );
    };

    const [t, i18n] = useTranslation();

    return (
        <CrudMain
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("sidebar.kullanicilar")}
            hideNewAddButton
            size={"lg"}
        >
            <Tab.Container defaultActiveKey={"guncelle"}>
                <Nav as="ul" className="nav-tabs">
                    <Nav.Item as="li" key={1}>
                        <Nav.Link eventKey={"guncelle"}>{t("tabs.kullaniciBilgileri")}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={2}>
                        <Nav.Link eventKey={"kullanicilar"}>{t("sidebar.arsivVeYonetimi")}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={3}>
                        <Nav.Link eventKey={"KullaniciDosyalari"}>
                            {t("tabs.KullaniciDosyalari")}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={4}>
                        <Nav.Link eventKey={"Roller"}>
                            {t("tabs.Roller")}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={5}>
                        <Nav.Link eventKey={"departmanlar"}>
                            {t("sidebar.departmanlar")}
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content className="pt-4">
                    {/* kullanıcı güncelleme */}
                    <Tab.Pane eventKey={"guncelle"} key={1}>
                        <FormikForm
                            isUpdating={isUpdating}
                            entityId={selectedRow && selectedRow.id}
                            entityFetchId="id"
                            endPointUrl="user/update"
                            fetchPointUrl="user/find"
                            editPointUrl="user/update"
                            arrangeBeforePersist={arrangeBeforePersist}
                            adaptDataForUpdate={adaptDataForUpdate}
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            closeModal={() => setShowModal(!showModal)}
                            refreshList={() => setRefreshList(!refreshList)}
                            aktif={'ahmed'}
                        >
                            <Field
                                name="fullName"
                                label={t("demandList.adiSoyadi")}
                                colNumber="12"
                                component={TextInput}
                                readOnly
                            />
                            <Field
                                name="email"
                                label={t("demandList.ePosta")}
                                colNumber="12"
                                component={TextInput}
                                readOnly
                            />
                            <Field
                                name="mobilePhone"
                                label={t("demandList.telefon")}
                                colNumber="12"
                                component={TextInput}
                                readOnly
                            />
                            <Field
                                name="username"
                                label={t("demandList.kullaniciAdi")}
                                colNumber="12"
                                component={TextInput}
                                readOnly
                            />
                            <Field
                                name="avukatKod"
                                label={t("demandList.avukatKodu")}
                                colNumber="12"
                                component={TextInput}
                            />
                            <Field
                                label={"Durum"}
                                name="durum"
                                checkboxText="Aktif"
                                colNumber="12"
                                component={Checkbox}
                                value={StatusCheckBoxValue}
                                onChangeFunc={(check, setFieldValue) => {

                                    let st = 90;

                                    if (!check)
                                        st = 91;

                                    request({
                                        url: "user/aktif-pasif",
                                        method: "POST",
                                        data: {
                                            body: {
                                                id: selectedRow.id,
                                                stId: st
                                            },
                                        },
                                    }
                                    );
                                }}
                            /*required*/
                            />

                            <Field
                                name="masrafCheckUpdate"
                                label={t("userRole.masraflarSekmesindeMi")}
                                colNumber="12"
                                checkboxText="Aktif"
                                component={Checkbox}
                                value={selectedRow?.masrafCheck ? true : false}
                            />
                        </FormikForm>
                    </Tab.Pane>
                    <Tab.Pane eventKey={"kullanicilar"} key={2}>
                        <Main>
                            <FormikForm
                                isUpdating={isUpdating}
                                entityId={selectedRow && selectedRow.id}
                                entityFetchId="id"
                                endPointUrl="user/arsiv-role-ekle"
                                fetchPointUrl="user/find-arsiv"
                                editPointUrl="user/arsiv-role-ekle"
                                arrangeBeforePersist={arrangeBeforePersistArchive}
                                adaptDataForUpdate={adaptDataForUpdateArchive}
                                initialValues={initialValuesArchive}
                                validationSchema={validationSchema}
                                closeModal={() => setShowModal(!showModal)}
                                refreshList={() => setRefreshList(!refreshList)}
                            >
                                {initialValuesArchive.id && (
                                    <div style={{ flexWrap: "wrap", flexDirection: "column" }}>
                                        <Field
                                            name="arsivYonetimIds"
                                            label={t("userRole.arsiv")}
                                            colNumber="12"
                                            component={CheckboxComponent}
                                            checkboxList={initialValuesArchive.arsivYonetimIds}
                                        />
                                    </div>
                                )}
                            </FormikForm>
                        </Main>
                    </Tab.Pane>
                    <Tab.Pane eventKey={"KullaniciDosyalari"} key={3}>
                        <FormikForm
                            isUpdating={false}
                            entityId={selectedRow && selectedRow.id}
                            entityFetchId="id"
                            endPointUrl="user/dokuman-ekle"
                            // fetchPointUrl="user/get-files"
                            editPointUrl="user/dokuman-ekle"
                            arrangeBeforePersist={arrangeBeforePersistFile}
                            adaptDataForUpdate={adaptDataForUpdateFile}
                            initialValues={initialValuesFile}
                            //closeModal={() => setShowFileModal(false)}
                            refreshList={() => setRefreshFileList(!refreshFileList)}
                            okButtonText={t("demandCreate.ekle")}
                            resetAfterSubmit={true}
                            validationSchema={validationSchema_file}
                        >
                            <Field
                                name="descr"
                                label={t("demandList.aciklama")}
                                colNumber="6"
                                component={TextInput}
                                required={true}
                            />
                            <Field
                                name="fileId"
                                label="Dosya"
                                colNumber="12"
                                required={true}
                                component={FileUpload}
                            />
                        </FormikForm>

                        <ListComponent
                            selectedRows={selectedRow}
                            entityName=""
                            endpoint="user/get-files"
                            keyField="id"
                            fileNameField="filename"
                            defaultPageSize={999999}
                            customBody={{
                                id: selectedRow && selectedRow.id,
                            }}
                            refreshList={refreshFileList}
                            columns={[
                                {
                                    dataField: "descr",
                                    text: t("demandList.aciklama"),
                                    sort: true,
                                },
                                {
                                    dataField: "filename",
                                    text: t("tabs.dosyaAdi"),
                                    sort: true,
                                },
                                {
                                    dataField: "createdDate",
                                    text: t("tabs.tarih"),
                                    formatter: formatDate,
                                    sort: true,
                                },
                                {
                                    dataField: "cuser.fullName",
                                    text: t("tabs.ekleyen"),
                                    sort: true,
                                }
                            ]}
                            actionButtonsObject={{
                                actions: [
                                    requestTo(ABT.DELETE, "user-file/delete"),
                                    requestTo(ABT.DOWNLOAD, "user-file/download"),
                                ],
                                generator: DefaultActionButtonGenerator,
                            }}
                        />
                    </Tab.Pane>
                    <Tab.Pane eventKey={"Roller"} key={4}>
                        {/* <UserRole history = {loc}/>  */}
                        {/* <UserCRoles/> */}

                        <UserRole
                            location={{ pathname: "/kullanıcı-rol", state: { row: { ...selectedRow } } }} 
                            showBackButton={false} 
                        />
                    </Tab.Pane>
                    <Tab.Pane eventKey={"departmanlar"} key={5}>
                        <UserDepartment 
                            location={{ pathname: "/kullanıcı-departman", state: { row: { ...selectedRow } } }} 
                            showBackButton={false} 
                        />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </CrudMain>
    )
}

export default UserModal